export default __webpack_public_path__ + "static/media/help14.050d113d.png";